import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../../assets/images/logo.png";
import SectionLink from "../common/SectionLink";
import "./Header.css";

const navItems = [
  { name: "Our work", id: "work" },
  { name: "Services", id: "services" },
  { name: "How we work", id: "process" },
  { name: "Why us", id: "about" },
  { name: "Contact", id: "contact" },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setIsOpen(false);

  return (
    <header
      className={`lk-header${isScrolled ? " is-scrolled" : ""}${
        isOpen ? " is-open" : ""
      }`}
    >
      <div className="lk-container lk-header-inner">
        <SectionLink
          to="home"
          className="lk-brand"
          aria-label="Lankovate Technologies home"
          onClick={closeMenu}
        >
          <span className="lk-brand-mark">
            <img src={logo} alt="" width="34" height="34" />
          </span>
          <span className="lk-brand-text">
            <strong>Lankovate</strong>
            <span>Technologies</span>
          </span>
        </SectionLink>

        <nav id="lk-nav" className="lk-nav" aria-label="Main">
          {navItems.map((item) => (
            <SectionLink
              key={item.name}
              to={item.id}
              className="lk-nav-link"
              onClick={closeMenu}
            >
              {item.name}
            </SectionLink>
          ))}
          <a
            href="#contact"
            className="lk-btn lk-btn-primary lk-nav-cta"
            onClick={closeMenu}
          >
            Get a quote
          </a>
        </nav>

        <button
          type="button"
          className="lk-burger"
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          aria-controls="lk-nav"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
};

export default Header;
